export const CASHBACK_TRAVEL = {
  Header: 'TÉRMINOS Y CONDICIONES CAMPAÑA – "10% Cashback RappiTravel"',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por medio de la presente, se da a conocer la Campaña denominada “10% Cashback RappiTravel ”, por medio de la cual los
        usuarios/consumidores de Rappi que realicen la orden de los productos que tengan el banner con la
        <strong>leyenda “10% Cashback”</strong>, en la sección RappiTravel, al interior de la plataforma de contacto Rappi, en
        productos seleccionados <strong>recibirán hasta $6,000.00</strong> (seis mil pesos 00/100 Moneda Nacional)
        <strong>de cashback en Créditos para ser utilizados dentro de la Plataforma de contacto Rappi</strong> conforme a
        las siguientes condiciones:`
      ]
    },
    {
      Title: null,
      Paragraphs: [
        `1. Campaña válida únicamente durante el periodo de tiempo comprendido entre las 12:01 A.M del 01 de febrero de 2021
        hasta las 11:59 P.M del 13 de febrero de 2021.`,
        `2. Campaña válida únicamente para órdenes realizadas en las zonas de cobertura de la plataforma de contacto Rappi
        al interior de los Estados Unidos Mexicanos.`,
        '3. Campaña válida únicamente para órdenes pagadas con Tarjeta de crédito y RappiPay.',
        `4. Campaña válida por usuarios/consumidores únicamente para órdenes de los productos en los que se señale la
        leyenda “10% Cashback” en la sección “Rappitravel” al interior de la plataforma de contacto Rappi. No se tendrán en
        cuenta las órdenes realizadas a través de cualquier otra tienda o sección de la plataforma de contacto Rappi o que no
        señalen la leyenda “10% Cashback”.`,
        `5. El valor del cashback al usuario/consumidor es de $6,000.00 (seis mil pesos 00/100 Moneda Nacional). El valor del
        cashback, en ningún caso podrá exceder la cantidad mencionada en el presente numeral.`,
        `6. Los Créditos los recibirá el usuario/consumidor posterior a la confirmación y pago de la compra o como máximo
        24 horas posteriores a la misma y podrán ser utilizados como fecha máxima hasta las 23:59 hrs del 13 de marzo de 2021.
        Los Créditos otorgados en el Cashback de esta promoción no son redimibles en Rappi Cash, Rappi Antojos ni Rappi
        apuestas.`,
        `7. En caso de que el usuario/consumidor realice una devolución de la compra realizada, en el momento del reembolso
        del producto se descontará el valor del Cashback que ya fue cargado a la cuenta del usuario/consumidor con ocasión de
        la presente Campaña, del saldo a favor de Créditos del usuario/consumidor. En caso de que el usuario/consumidor
        no tenga saldo de Créditos a favor a la fecha del desembolso, Rappi descontará el valor del Cashback que fue
        otorgado del valor total de la compra inicial realizada por el usuario/consumidor, sobre la cual se realizará el
        reembolso.`,
        `8. Campaña válida para máximo cuatro (4) órdenes por usuario/consumidor durante la vigencia de la promoción para
        recibir el cashback.`,
        '9. Campaña válida hasta agotar existencias.',
        '10. Campaña es acumulable con otras promociones.',
        `11. Rappi se reserva el derecho de restringir o retener los Créditos ya otorgados, en aquellos casos donde se
        compruebe que el Usuario/Consumidor adquirió los productos y/o servicios exhibidos en el Botón Rappi Travel para
        fines comerciales y no de uso personal.`,
        `12. Se aclara que los presentes términos y condiciones se encuentran sujetos a los Términos y Condiciones de Uso de
        la Plataforma Rappi, los cuales se encuentran en el siguiente link: <a
        href="https://legal.rappi.com/mexico/terminos-y-condiciones-de-uso-de-plataforma-rappi-3/">
        https://legal.rappi.com/mexico/terminos-y-condiciones-de-uso-de-plataforma-rappi-3/</a>`,
        `13. El usuario/consumidor reconoce y acepta que la información proporcionada y registrada en la plataforma de
        contacto Rappi, es veraz y fidedigna, haciéndose completamente responsable por su falsedad.`,
        '14. Rappi se reserva el derecho de cancelar órdenes si detecta intención de fraude.',
        '15. Rappi no comercializa productos puesto que es solo una plataforma de contacto.',
        `16. En caso de cualquier queja que pueda surgir con respecto a los Términos y Condiciones, así como en relación a
        la presente campaña, el usuario acepta y reconoce que deberá dirigirla a Tecnologías Rappi S.A.P.I. de C.V. por
        medio del portal de PROFECO denominado “Concilianet”, cuya liga es la siguiente:
        <a href="https://concilianet.profeco.gob.mx/Concilianet/inicio.jsp">
        https://concilianet.profeco.gob.mx/Concilianet/inicio.jsp</a>`,
      ]
    }
  ]
};
